// All images are hosted locally under /app/frontend/public/images/ so they're
// served from the same origin as the site — no third-party CDN dependency.

export const HISTORIC_SALES = [
  { img: "/images/historic/jordan-550k.png", title: "Michael Jordan Game Worn" },
  { img: "/images/historic/lebron-242k.png", title: "LeBron James Game Worn" },
  { img: "/images/historic/brady-500k.png", title: "Tom Brady Game Worn" },
  { img: "/images/historic/brown-350k.png", title: "Jim Brown Game Worn" },
  { img: "/images/historic/jordan-264k.png", title: "Michael Jordan Game Worn" },
  { img: "/images/historic/payton-120k.png", title: "Walter Payton Game Worn" },
  { img: "/images/historic/aaron-110k.png", title: "Hank Aaron Game Worn" },
  { img: "/images/historic/lebron-97k.png", title: "LeBron James Game Worn" },
  { img: "/images/historic/jordan-67k.png", title: "Michael Jordan Game Worn" },
  { img: "/images/historic/jordan-61k.png", title: "Michael Jordan Game Worn" },
];

export const PLAYER_COLLECTIONS = [
  { img: "/images/players/iverson.png",      name: "Allen Iverson" },
  { img: "/images/players/murphy.png",       name: "Calvin Murphy" },
  { img: "/images/players/beaty.png",        name: "Zelmo Beaty" },
  { img: "/images/players/hunter.png",       name: "Steven Hunter" },
];

export const MEDIA_LOGOS = [
  { img: "/images/media/usa-today.png",    name: "USA Today" },
  { img: "/images/media/yahoo-sports.png", name: "Yahoo Sports" },
  { img: "/images/media/morningstar.png",  name: "Morningstar" },
];

// Interleaved deck for the Media Reach & Player Collections ticker.
// `kind` controls card rendering (logos sit centered with padding; players fill the frame).
export const COLLECTIONS_TICKER = [
  { kind: "media",  img: MEDIA_LOGOS[0].img,        name: MEDIA_LOGOS[0].name },
  { kind: "player", img: PLAYER_COLLECTIONS[0].img, name: PLAYER_COLLECTIONS[0].name },
  { kind: "media",  img: MEDIA_LOGOS[1].img,        name: MEDIA_LOGOS[1].name },
  { kind: "player", img: PLAYER_COLLECTIONS[1].img, name: PLAYER_COLLECTIONS[1].name },
  { kind: "media",  img: MEDIA_LOGOS[2].img,        name: MEDIA_LOGOS[2].name },
  { kind: "player", img: PLAYER_COLLECTIONS[2].img, name: PLAYER_COLLECTIONS[2].name },
  { kind: "media",  img: "/images/media/nasdaq.png", name: "Nasdaq" },
  { kind: "player", img: PLAYER_COLLECTIONS[3].img, name: PLAYER_COLLECTIONS[3].name },
];

// Category taxonomy — main category → list of subcategories.
// Only categories with available lots are shown in the UI (filtered client-side).
export const CATEGORY_TREE = {
  "Basketball":       ["Game Used", "Sports Cards", "Autographs", "Stadia"],
  "Football":         ["Game Used", "Sports Cards", "Autographs", "Stadia"],
  "Baseball":         ["Game Used", "Sports Cards", "Autographs", "Stadia"],
  "Hockey":           ["Game Used", "Sports Cards", "Autographs", "Stadia"],
  "Golf":             ["Game Used", "Sports Cards", "Autographs", "Stadia"],
  "Soccer":           ["Game Used", "Sports Cards", "Autographs", "Stadia"],
  "Boxing":           ["Fight Worn/Used", "Cards", "Autographs", "Stadia"],
  "Tennis":           ["Match Worn/Used", "Cards", "Autographs", "Stadia"],
  "Music":            ["Celebrity Worn/Used", "Cards", "Autographs", "Props", "Misc."],
  "TV & Film":        ["Screen Worn/Used", "Autographs", "Cards", "Props"],
  "Historical":       ["Autographs", "Cards", "Documents", "Memorabilia"],
  "Americana":        ["Autographs", "Cards", "Documents", "Memorabilia"],
  "Comic Books":      ["Golden Age", "Silver Age", "Bronze Age", "Modern", "Variants"],
  "Action Figures":   ["Vintage", "Modern", "Limited Edition", "Convention Exclusive"],
  "Video Games":      ["Sealed", "Graded", "Vintage", "Modern"],
  "Coins & Currency": ["US Coins", "World Coins", "Paper Currency", "Bullion"],
};

// Marketplace authentication requirements per category/subcategory.
// Surfaced to sellers when they pick a category in the sell-in-marketplace form
// and enforced as required documentation before admin can approve a listing.
export const MARKETPLACE_AUTHENTICATORS = {
  "Game Used": ["Real Game Used (RGU)", "MEARS", "Meigray", "Sports Investors", "Resolution Photo Matching", "PSA", "Davious", "RAI Photo Matching", "Other"],
  "Fight Worn/Used": ["Real Game Used (RGU)", "MEARS", "Meigray", "Sports Investors", "Resolution Photo Matching", "PSA", "Davious", "RAI Photo Matching", "Other"],
  "Match Worn/Used": ["Real Game Used (RGU)", "MEARS", "Meigray", "Sports Investors", "Resolution Photo Matching", "PSA", "Davious", "RAI Photo Matching", "Other"],
  "Celebrity Worn/Used": ["Real Game Used (RGU)", "MEARS", "Meigray", "Sports Investors", "Resolution Photo Matching", "PSA", "Davious", "RAI Photo Matching", "Other"],
  "Screen Worn/Used": ["Real Game Used (RGU)", "MEARS", "Meigray", "Sports Investors", "Resolution Photo Matching", "PSA", "Davious", "RAI Photo Matching", "Other"],
  "Autographs": ["PSA", "JSA", "Beckett", "UDA (plus additional)", "Other"],
  "Cards":        ["PSA", "BGS", "SGC", "CGC Cards", "Other"],
  "Sports Cards": ["PSA", "BGS", "SGC", "CGC Cards", "Other"],
  "US Coins":     ["PCGS", "NGC", "ICG", "Other"],
  "World Coins":  ["PCGS", "NGC", "ICG", "Other"],
  "Bullion":      ["PCGS", "NGC", "ICG", "Other"],
  "Paper Currency": ["PMG", "PCGS Banknote", "Other"],
  "Golden Age":   ["CGC", "CBCS", "PGX", "Other"],
  "Silver Age":   ["CGC", "CBCS", "PGX", "Other"],
  "Bronze Age":   ["CGC", "CBCS", "PGX", "Other"],
  "Modern":       ["CGC", "CBCS", "PGX", "Other"],
  "Variants":     ["CGC", "CBCS", "PGX", "Other"],
  "Sealed":       ["CGC Video Games", "VGA", "WATA", "Other"],
  "Graded":       ["CGC Video Games", "VGA", "WATA", "Other"],
  "Vintage":      ["AFA", "CGA", "CAS", "Other"],
  "Limited Edition": ["AFA", "CGA", "CAS", "Other"],
  "Convention Exclusive": ["AFA", "CGA", "CAS", "Other"],
  "Documents":    ["PSA", "JSA", "Beckett", "Other"],
  "Memorabilia":  ["PSA", "JSA", "Beckett", "MEARS", "Other"],
  "Props":        ["PSA", "JSA", "Beckett", "Other"],
  "Stadia":       ["PSA", "JSA", "Beckett", "Other"],
  "Misc.":        ["Other"],
};

// Marketplace business rules — kept here so both sell-form and detail pages
// reference the same constants. Mirror any change here in /app/backend/server.py
// (MARKETPLACE_MIN_PRICE etc).
export const MARKETPLACE = {
  MIN_PRICE: 500,            // hard floor — items below this are rejected
  MAX_DURATION_DAYS: 45,     // default + maximum listing duration
  BUYER_MARKUP_PCT: 22,      // 22% buyer's premium added on top of seller's ask
  SELLER_FEE_PCT: 0,         // seller receives 100% of their ask; IA keeps the buyer's premium
  SHIP_TO: {
    name: "Infinite Auctions LLC",
    line1: "530 E. Hunt Hwy",
    line2: "Suite 103-225",
    city: "San Tan Valley",
    state: "AZ",
    zip: "85143",
    email: "info@infiniteauctions.com",
  },
};
